import type { CustomersRelationshipsRequestBody } from '@customerio/hydra-ui-api';
import type { Customer } from '@/services/db/customer/entity';
import type { ObjectRecord } from '@/services/db/object/entity';

type RelationshipInput = CustomersRelationshipsRequestBody['relationships'][number];

/**
 * One relationship per selected person/object pair: every person is related to
 * every object, carrying the same attributes.
 *
 * `entity1_id` is the person's `internal_id` (their `cio_id`), which is the id
 * the relationships endpoint resolves customers by.
 *
 * `created_at` is sent because the generated request type requires it; the
 * endpoint itself defaults it when omitted (see the spec note in the PR).
 */
export function relationshipInputs(
  people: readonly Customer[],
  objects: readonly ObjectRecord[],
  attributes: Readonly<Record<string, string>>,
): RelationshipInput[] {
  const created_at = Math.floor(Date.now() / 1000);

  return objects.flatMap((record) =>
    people.map((person) => ({
      entity1_type: 'customer',
      entity1_id: person.internal_id,
      entity2_type: 'object',
      entity2_id: record.id,
      attributes,
      created_at,
    })),
  );
}
